/* istanbul ignore file */
import { SidebarMenuItem, SidebarMenuItemProps } from 'framework/ui/menu';
import React from 'react';

const ContactsMenuItem = ({ linkUrl, ...props }: SidebarMenuItemProps) => (
  <SidebarMenuItem {...props} linkUrl={linkUrl} icon="group" />
);

ContactsMenuItem.displayName = 'Contacts';

export default ContactsMenuItem;
